export default __webpack_public_path__ + "static/media/3435 knife block B top.4b1155dd.png";